import {Component, OnInit, OnDestroy, AfterViewInit, inject} from '@angular/core';
import {InterviewStreamService} from './services/interview.service';
import {StreamComponent} from '../../common/stream.component';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'interview-settings',
    templateUrl: './interview-settings.component.html',
    styleUrls: [],
    standalone: false
})

export class InterviewSettingsComponent implements OnInit, AfterViewInit {
    private translate = inject(TranslateService);

    navigator = <any>navigator;
    audioSelect: any;
    videoSelect: any;
    audioOutputSelect: any;
    stream: any;
    videoSubscription: any;

    constructor(private _videoService: InterviewStreamService) {}

    ngOnInit() {
        this.audioSelect = document.querySelector('select#audioSource');
        this.videoSelect = document.querySelector('select#videoSource');
        this.audioOutputSelect = document.querySelector('select#outputSource');
        this.navigator.mediaDevices.enumerateDevices()
            .then(this.selectDevices.bind(this))
            .then(this.getStream.bind(this));
    }

    selectDevices(deviceInfos) {
        for (let i = 0; i !== deviceInfos.length; ++i) {
            let deviceInfo = deviceInfos[i];
            let option = document.createElement('option');
            option.value = deviceInfo.deviceId;
            if (deviceInfo.kind === 'audioinput') {
                option.text = deviceInfo.label ||
                    'microphone ' + (this.audioSelect.length + 1);
                this.audioSelect.appendChild(option);
            } else if (deviceInfo.kind === 'videoinput') {
                option.text = deviceInfo.label || 'camera ' +
                    (this.videoSelect.length + 1);
                this.videoSelect.appendChild(option);
            } else {
                console.log('Found another kind of device: ', deviceInfo);
            }
        }
    }

    getStream() {
        this.videoSubscription = this._videoService.currentStream.subscribe(video => {
            if (video) {
                this.stream = video;
                this.stream.play();
            }
        });
    }

    ngAfterViewInit() {
        document.title = this.translate.instant('interviews.Device Setup');
    }

    ngOnDestroy() {
        this.videoSubscription.unsubscribe();
        this._videoService.stopVideo(this.stream);
    }

}
